exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.preview {\n  max-height: 100px;\n  max-width: 100px; }\n\nth.name {\n  width: 15rem; }\n\nth.size {\n  width: 3rem; }\n\nth.close {\n  width: 2rem; }\n\n.container {\n  margin: 8px; }\n\n.action-buttons {\n  margin: 8px 0; }\n", ""]);

// exports
